import suiteService from 'qreventos-suite/services';
import invitacionService from 'qreventos-suite/invitaciones';

class SuiteConfig {
    evento:number = 804;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = '57fc69c5-8f6e-43cd-85bc-aac1c4d8e04c-804';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  

      invitacionService.clientId = this.clientId;
      invitacionService.token = this.token;
    }
}

export default new SuiteConfig();
